$(function () {
    // if (location.href.indexOf('popuppage') >= 0 || location.href.indexOf('imageuploaderpopuppage') >= 0) {
    //     var $doc = $(document);
    //     var $win = $(window);
    //     var $body = $('body');

    //     window.parent.setIframeHeight($body.height());
    //     $(window).resize(function () {
    //         window.parent.setIframeHeight($body.height());
    //     });
    // }
});
